const statusColors = {
  Alquiler: "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400",
  Venta: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400",
  Alquilado: "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400",
  Vendido: "bg-gray-200 text-gray-600 dark:bg-gray-700/30 dark:text-gray-400",
};

const typeBadgeColors = {
  Casa: "bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-400",
  Departamento: "bg-purple-100 text-purple-700 dark:bg-purple-900/30 dark:text-purple-400",
  Terreno: "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-400",
  Local: "bg-teal-100 text-teal-700 dark:bg-teal-900/30 dark:text-teal-400",
  Galpon: "bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400",
  Galpón: "bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-400",
};

export function getStatusClasses(state) {
  return statusColors[state] || "bg-gray-100 text-gray-600 dark:bg-gray-700/30 dark:text-gray-400";
}

export function getTypeBadgeClasses(type) {
  return typeBadgeColors[type] || "bg-gray-100 text-gray-600 dark:bg-gray-700/30 dark:text-gray-400";
}
